// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class QuoteRequestGroup extends PFixFieldSet {
    get tradableId() {
        return super.GetValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
    }
    set tradableId(value) {
        super.SetField(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, value);
    }
    get routeId() {
        return super.GetValue(FieldsFactory.FIELD_ROUTE_ID);
    }
    set routeId(value) {
        super.SetField(FieldsFactory.FIELD_ROUTE_ID, value);
    }
    constructor(pfixFieldSet) {
        super(FieldsFactory.QUOTE_REQUEST_GROUP, null, pfixFieldSet);
    }
}
